import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UseFormSetError } from "react-hook-form";
import { apiClient } from "../../utils/api";
import { useAuthStore } from "../../store/authStore";
import { SignInRequest, SignInResponse, SignInFormData } from "../../types/auth";

interface UseSignInReturn {
  isLoading: boolean;
  apiError: string;
  signIn: (data: SignInFormData, setError: UseFormSetError<SignInFormData>) => Promise<void>;
  clearApiError: () => void;
}

const useSignIn = (): UseSignInReturn => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  
  const { signIn: storeSignIn } = useAuthStore();

  const signIn = async (data: SignInFormData, setError: UseFormSetError<SignInFormData>) => {
    setIsLoading(true);
    setApiError("");

    try {
      const requestBody: SignInRequest = {
        x_id: data.x_id,
        app_key: data.app_key,
        platform: data.platform || "aivy"
      };

      const response = await apiClient.post("/api/v1/auth/signin", requestBody);

      const responseData: SignInResponse = response.data;

      if (responseData.status && !responseData.unmatched) {
        storeSignIn(
          {
            accessToken: responseData.access_token,
            refreshToken: responseData.refresh_token,
          },
          responseData.data
        );
        
        navigate("/");
      } else if (responseData.unmatched) {
        setApiError("계정 정보가 일치하지 않습니다. 아이디와 비밀번호를 확인해주세요.");
      } else {
        setApiError("로그인에 실패했습니다. 다시 시도해주세요.");
      }
    } catch (err) {
      console.error("로그인 오류:", err);
      setApiError("네트워크 오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      setIsLoading(false);
    }
  };

  const clearApiError = () => {
    setApiError("");
  };

  return {
    isLoading,
    apiError,
    signIn,
    clearApiError,
  };
};

export default useSignIn; 